var dlgdrag = {
    directives: {
		dlgdrag: {
			inserted(el, binding, vnode){
				var dlgw;
				var dlgh;
				var winw;
				var winh;
				var retrynum=0;
				$(el).bind('reposition',()=>{
					dlgw=$(el).width();
					dlgh=$(el).height();
					if(dlgw==0){
						if(retrynum<100){
							setTimeout(()=>{
								$(el).trigger('reposition');
							},60)
							retrynum+=1;
						}
						return;
					}
					winw=$(window).width();
					winh=$(window).height();
					var left=parseInt((winw-dlgw)/2)+'px';
					var top=parseInt((winh-dlgh)/2)+'px';
					$(el).css({left:left,top:top})
				});
				$(el).css('position','').trigger('reposition');
				$(el).draggable({
					handle:'.dig_title',
					drag(event,ui){
						if(dlgw>=320&&ui.position.left<320-dlgw){
							ui.position.left=320-dlgw;
						}else if(dlgw<320&&ui.position.left<0){
							ui.position.left=0;
						} 
						if(ui.position.top<-23) ui.position.top=-23;
						if(ui.position.left+320>winw){
							ui.position.left=winw-320;
						}
						if(ui.position.top+70>winh){
							ui.position.top=winh-70;
						}
					}
				}).css('position','');

			},
			unbind(el){
				$(el).unbind('reposition');
				$(el).css({left:'',top:''})
				$(el).draggable('destroy');
			}
		}
	},
}

export default dlgdrag;




// WEBPACK FOOTER //
// ./src/common/dlgdrag.js